import { Content } from '@angular/compiler/src/render3/r3_ast';
import { Component, OnInit, ChangeDetectionStrategy, Input, ContentChild, ElementRef, ViewChild, HostListener, HostBinding } from '@angular/core';
import { ApiService } from '@services/api.service';

const canvasWrapper = 'canvasWrapper';
const contentNode = 'content';

@Component({
  selector: 'qr-code',
  template: `<div class="h" #${contentNode}><ng-content></ng-content></div><div class="w" #${canvasWrapper}></div>`,
  styles: [`.h { display: none; }`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrcodeComponent implements OnInit {

	private _currentlyEncodedValue!: string;

	@ViewChild(contentNode, {read: ElementRef, static: true}) contentRef: ElementRef<HTMLElement>;

	@ViewChild(canvasWrapper, {read: ElementRef, static: true}) targetRef: ElementRef<HTMLElement>;

	constructor(
		private _api: ApiService,
	) { }

	ngOnInit(): void {
	}

	ngAfterContentChecked() {
		const cur = this._currentlyEncodedValue;
		const inc = this.contentRef.nativeElement?.innerText;
		if (cur !== inc) {
			this._render(inc);
		}
	}


	private _render(value: string) {
		const t = this.targetRef.nativeElement;
		t.innerHTML = '';
		if (value) {
			this.targetRef.nativeElement.appendChild(
				this._api.qrcode.toCanvas(value)
			);
			this._currentlyEncodedValue = value;
		}
	}
}
